import React from 'react';
import Cookies from 'js-cookie';

import VBInput from "@virkesborsen/vb-js-commons/lib/components/new/vbInput";
import VBDropdown from "@virkesborsen/vb-js-commons/lib/components/new/vbDropdown";
import VBLoadingScreen from "@virkesborsen/vb-js-commons/lib/components/vbLoadingScreen";

import { validateForm } from '../api';

import * as Opt from '../components/editor/Helpers';
import ColorSelector from '../components/editor/fields/ColorSelector';

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler } from 'chart.js';
import { Line } from 'react-chartjs-2';

import { LoginContext } from "../components/login/context/LoginContext";

ChartJS.register( CategoryScale, LinearScale, PointElement, LineElement,  Tooltip, Legend, Filler );

class PropertyValue extends React.Component {
    static contextType = LoginContext;
    
    constructor() {
        super();

        const urlParams = new URLSearchParams(window.location.search);

        this.state = {
            errors: {},
            loading: false,
            userForm: {muni: urlParams.get('muni') ? parseInt(urlParams.get('muni')) : undefined, area: urlParams.get('area') ? urlParams.get('area') : undefined},
        }
    }

    getPriceData() {
        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken')
        }

        const requestData = {
            area: this.state.userForm.area,
            muni: this.state.userForm.muni
        }

        return fetch("/price-api/prop-price-lite/", {
            method: 'POST',
            headers: headers,
            credentials: 'same-origin',
            body: JSON.stringify(requestData)}).then(resp => {
                if (resp.ok) {
                    resp.json().then((json) => {
                        let lineData = json.data
                        lineData.line.datasets.map(i => {
                            if(i.label == 'Lägsta kubikpris') { i.borderColor = '#2FAF9A'; i.backgroundColor = 'rgb(47, 175, 175, 0.3)' }
                            if(i.label == 'kr/m³sk') { i.borderColor = '#F26157'; i.backgroundColor = 'rgb(242, 97, 87, 0.3)' }
                            if(i.label == 'Högsta kubikpris') { i.borderColor = '#6A58C6'; i.backgroundColor = 'rgb(106, 88, 198, 0.3)' }
                            i.borderWidth = 4
                            i.pointBorderWidth = 3
                            i.fill = true
                        })
                        gtag("event", "did_prop_price_lite", { method: "Site" });
                        this.setState({ data: lineData, loading: false })
                    })
                } else {
                    alert('Something went wrong!')
                    this.setState({ loading: false })
                }
        });
    }

    handleSubmit(e) {
        const LoginContext = this.context;
        e.preventDefault()

        let checkList = ['muni', 'area'];
        let data = this.state.userForm;

        // Validate the fields
        let validation = validateForm(data, checkList, false);

        if (Object.keys(validation).length !== 0) {
            this.setState({ errors: validation })
        } else {
            if(LoginContext.isLogged) {
                this.setState({ loading: true, errors: {} })
                this.getPriceData()
            } else {
                LoginContext.setShow(true)
            }
        }
    } 

    render() {
        return <div className="container-fluid p-0">
            <div className="bg-white">
                <VBLoadingScreen show_loading={this.state.loading} />

                <div className={`container bg-${this.props.backgroundColor} ${this.props.textColor}`}>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 pb-2">
                            <form className='mb-5' onSubmit={(e) => this.handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-12 col-xl-6">
                                        <VBDropdown
                                            label={<label className='fw-medium pb-1 mt-3'>Kommun</label>}
                                            initial={this.state.userForm?.muni}
                                            placeholder="Välj kommun"
                                            options={Window.react_data.lists.munis}
                                            error={this.state.errors.muni}
                                            onFocus={() => this.setState({ errors: {...this.state.errors, muni: ''}})}
                                            onChange={(val) => this.setState({ userForm: {...this.state.userForm, muni: parseInt(val.value)}})} />
                                    </div>

                                    <div className="col-12 col-xl-6">
                                        <VBInput
                                            label={<label className='fw-medium pb-1 mt-3'>Skogsareal</label>}
                                            initial={this.state.userForm?.area}
                                            placeholder="Välj areal"
                                            type="number"
                                            error={this.state.errors.area}
                                            onFocus={() => this.setState({ errors: {...this.state.errors, area: ''}})}
                                            onChange={(val) => this.setState({userForm:{ ...this.state.userForm, area: val }})} />
                                    </div>
                                </div>
                                
                                <div className='mt-3 col-12 col-md-5'>
                                <button type="submit" className="n-btn btn-forest-green w-100">Visa fastighetsvärdering</button>
                                </div>
                            </form>

                            {this.state.data && <div className="row mt-5">
                                <div className="col-12">
                                    <h3 className={`n-md-h4 ${this.props.textColor}`}>Fastighetsvärde:</h3>
                                </div>

                                <div className="col-4 d-flex flex-column justify-content-end">
                                    <p className="text-center mb-0">{Math.round(this.state.data.bar.find(d => d.id === 'Lågt').value).toLocaleString('sv-SE')} kr</p>
                                    <div className="bg-supp-spruce rounded-5 w-75 mx-auto" style={{height: `${Math.round(300 * (1 / this.state.data.bar.find(d => d.id === 'Högt').value * this.state.data.bar.find(d => d.id === 'Lågt').value))}px`}}></div>
                                    <p className="text-center mt-1">Lågt</p>
                                </div>

                                <div className="col-4 d-flex flex-column justify-content-end">
                                    <p className="text-center mb-0">{Math.round(this.state.data.bar.find(d => d.id === 'Medel').value).toLocaleString('sv-SE')} kr</p>
                                    <div className="bg-supp-plum rounded-5 w-75 mx-auto" style={{height: `${Math.round(300 * (1 / this.state.data.bar.find(d => d.id === 'Högt').value * this.state.data.bar.find(d => d.id === 'Medel').value))}px`}}></div>
                                    <p className="text-center mt-1">Medel</p>
                                </div>

                                <div className="col-4">
                                    <p className="text-center mb-0">{Math.round(this.state.data.bar.find(d => d.id === 'Högt').value).toLocaleString('sv-SE')} kr</p>
                                    <div className="bg-supp-scarlet rounded-5 w-75 mx-auto" style={{height: "300px"}}></div>
                                    <p className="text-center mt-1">Högt</p>
                                </div>

                                <div className="col-12 mt-3">
                                    <h3 className={'mb-3 mt-4 n-md-h4 ' + `${this.props.textColor}`}>Historiska fastighetspriser (kr/m³sk) :</h3>

                                    <Line data={this.state.data.line} options={{ responsive: true, plugins: {datalabels: { display: false}} }} style={{minHeight: "300px"}} />
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

PropertyValue.defaultProps = {
    textColor: "neutral-charcoal",
    backgroundColor: "white",
    pageUrl: "",
}

PropertyValue.fields = {
    pageUrl: {
        type: "text",
    },
    backgroundColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
    },
    textColor: {
        type: "select",
        options: Opt.colorVariables
    },

}

export default PropertyValue;
